const METERS_IN_MILE = 1609.34;
const FEET_IN_METER = 3.28084;
export const FEET_IN_MILE = 5280;

export const metersToFeet = (meters: number) => meters * FEET_IN_METER;
export const metersToMiles = (meters: number) => meters / METERS_IN_MILE;

export const roundToOneDecimalPlace = (n: number) => Math.round(n * 10) / 10;
export const roundToNearestTen = (n: number) => Math.round(n / 10) * 10;
export const roundUpToWholeNumber = (n: number) => Math.ceil(n);
